"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var fp_1 = (0, tslib_1.__importDefault)(require("lodash/fp"));
var config_1 = require("../config");
var utils_1 = require("../utils");
var HAS_WARNING_BEEN_LOGGED = false;
var useHoneycomb = function () {
    var Rest = (0, config_1.useNTConfig)().Rest;
    var hcUrl = fp_1.default.get('Observability.endpoint', Rest);
    var hcSend = function (name, hcTraceID) {
        if (!hcUrl) {
            if (!HAS_WARNING_BEEN_LOGGED) {
                // eslint-disable-next-line no-console
                console.warn('Observability endpoint is not defined. Disabling Honeycomb instrumentation');
                HAS_WARNING_BEEN_LOGGED = true;
            }
            return null;
        }
        return (0, axios_1.default)({
            method: 'POST',
            url: hcUrl,
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                name: name,
                'trace.trace_id': hcTraceID,
                'trace.span_id': (0, utils_1.uniqueKey)(),
            },
        });
    };
    return { hcSend: hcSend };
};
exports.default = useHoneycomb;
